import { useTheme as y, getSafeGutter as C, getSizeValue as S } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as l } from "@bedrock-layout/type-utils";
import d from "react";
const h = l(
  ({ as: t, gutter: a, columns: o = 1, style: n, switchAt: e, ...r }, m) => {
    const s = y(), c = C(s, a), f = o > 0 ? o : 1, u = n ?? {}, i = S(s, e) ?? e, p = t ?? "div";
    return /* @__PURE__ */ d.createElement(
      p,
      {
        ref: m,
        "data-bedrock-columns": "",
        style: {
          ...u,
          "--gutter": c,
          "--columns": f,
          "--switchAt": i
        },
        ...r
      }
    );
  }
);
h.displayName = "Columns";
const b = (t) => typeof t == "number" ? t : 1, v = l(
  ({ as: t, span: a, style: o, offsetStart: n = 0, offsetEnd: e = 0, ...r }, m) => {
    const s = n > 0 ? n : void 0, c = e > 0 ? e : void 0, f = o ?? {}, u = t ?? "div";
    return /* @__PURE__ */ d.createElement(
      u,
      {
        "data-bedrock-column": !0,
        ref: m,
        style: {
          ...f,
          "--span": Math.max(b(a), 1),
          "--offsetStart": s,
          "--offsetEnd": c
        },
        ...r
      }
    );
  }
);
v.displayName = "Column";
export {
  v as Column,
  h as Columns
};
